module.exports = __webpack_public_path__ + "static/1194829220.e197fe68.jpg";